<template>
  <VueJsModalPrimary
    v-bind="{ ...getModalAttrs, ...$attrs }"
    v-on="$listeners"
    @before-open="beforeOpen"
  >
    <div :style="style.container">
      <HeaderLargePrimary>
        Publish Survey
      </HeaderLargePrimary>
      <template v-if="page === 1">
        <TextRegular :style="style.instruction">
          By publishing a survey, you can request all members on your workspace to respond to it. The survey will appear on every member's home screen until it is completed.<br><br>
          Would you like to proceed?
        </TextRegular>
        <div :style="style.buttons">
          <ButtonSecondary @click="close">
            Cancel
          </ButtonSecondary>
          <ButtonPrimary @click="() => { page = 2; }">
            Proceed
          </ButtonPrimary>
        </div>
      </template>
      <template v-else-if="page > 1">
        <div :style="style.expirationContainer">
          <TextRegular>
            Select the expiration policy for the survey:
          </TextRegular>
          <RadioListSecondary
            v-model="selectedExpirationType"
            :disableDeselect="true"
            :idKey="'type'"
            :items="surveyExpirations"
            :labelKey="'label'"
            :style="style.list"
          />
        </div>
        <div :style="style.buttons">
          <ButtonSecondary @click="close">
            Cancel
          </ButtonSecondary>
          <ButtonPrimary @click="$emit('publish-survey', selectedExpiration)">
            Publish
          </ButtonPrimary>
        </div>
      </template>
    </div>
  </VueJsModalPrimary>
</template>

<script>
  import ButtonPrimary from '@modules/v2/button/button-primary'
  import ButtonSecondary from '@modules/v2/button/button-secondary'
  import HeaderLargePrimary from '@modules/v2/header/header-large-primary'
  import RadioListSecondary from '@modules/v2/radio-list/radio-list-secondary'
  import TextRegular from '@modules/v2/text/text-regular'
  import VueJsModalPrimary from '@modules/v2/modal/vue-js-modal-primary'
  import { Layout } from '@js/styles'
  import { mapGetters, mapState } from 'vuex'
  import { MODAL_WINDOW_NAMES, SURVEY_EXPIRATIONS } from '@js/constants'

  export default {
    name: 'ModalSurveyPublishPrimary',
    inheritAttrs: false,
    components: {
      ButtonPrimary,
      ButtonSecondary,
      HeaderLargePrimary,
      RadioListSecondary,
      TextRegular,
      VueJsModalPrimary,
    },
    data: function () {
      return {
        name: MODAL_WINDOW_NAMES.PUBLISH_SURVEY_PRIMARY,
        page: 1,
        selectedExpirationType: null,
        survey: {},
        style: {
          buttons: {
            alignItems: 'flex-end',
            display: 'flex',
            justifyContent: 'space-between',
            width: '100%',
          },
          container: {
            display: 'flex',
            flexDirection: 'column',
            height: '100%',
            justifyContent: 'space-between',
            padding: Layout.space.lg,
            width: '100%',
          },
          expirationContainer: {
            margin: `${Layout.space.xl} 0`,
          },
          instruction: {
            margin: `${Layout.space.xl} 0`,
          },
          list: {
            margin: `${Layout.space.md} auto 0`,
            width: '100%',
          },
        },
      };
    },
    created: function () {
      this.selectedExpirationType = this.getDefaultSurveyExpiration.type;
    },
    computed: {
      ...mapGetters(
        'globalVariables',
        ['getDefaultSurveyExpiration', 'getSurveyExpirationByType'],
      ),
      ...mapState({
        surveyExpirations: state => state.globalVariables.data.surveyExpirations,
      }),
      getModalAttrs: function () {
        return {
          height: this.page === 1 ? 'auto' : '400px',
          maxWidth: 480,
          maxHeight: this.page === 1 ? 400 : 400,
          minHeight: this.page === 1 ? 275 : 400,
          name: this.name,
        };
      },
      selectedExpiration: function () {
        return this.surveyExpirations
          .filter(elem => elem.type === this.selectedExpirationType)[0];
      },
    },
    methods: {
      beforeOpen: function (e) {
        this.clearCache();
        this.survey = e.params.survey;
      },
      clearCache: function () {
        this.page = 1;
        this.survey = {};
        this.selectedExpirationType = this.getDefaultSurveyExpiration.type;
      },
      close: function () {
        this.clearCache();
        this.$modal.hide(this.name);
      },
    },
  };
</script>
